import { HeaderIcon, IconSearch } from '@banhala/ui-kit';
import { useNavigator } from '../../utils';
import { useLogAnalyticsEvent } from '../../hooks/useLogAnalyticsEvent';

export const SearchIcon = () => {
  const { navigator } = useNavigator();
  const logAnalyticsEvent = useLogAnalyticsEvent();

  const handlePress = () => {
    logAnalyticsEvent({
      channel: ['firebase', 'facebook', 'amplitude', 'ablylog'],
      name: 'CLICK_SEARCH',
    });
    navigator.moveToSearch();
  };

  return (
    <HeaderIcon onPress={handlePress}>
      <IconSearch />
    </HeaderIcon>
  );
};
